import React from 'react'
import { Switch, Route, Redirect, useRouteMatch, useParams } from 'react-router-dom'
import HelpLayout from './HelpLayout'
import HelpArticle from './HelpArticle'
import { helpManifest, getDefaultArticle } from './helpManifest'

function HelpLanding () {
  const { url } = useRouteMatch()
  const basePath = url.endsWith('/') ? url.slice(0, -1) : url
  const defaultArticle = getDefaultArticle()

  if (defaultArticle) {
    return <Redirect to={`${basePath}/${defaultArticle.slug}`} />
  }

  return (
    <div className='p-4'>
      <h1>Help</h1>
      <p>No help content is available yet.</p>
    </div>
  )
}

function SectionLanding () {
  const { url } = useRouteMatch()
  const { section } = useParams()
  const basePath = url.endsWith('/') ? url.slice(0, -1) : url

  const sectionEntry = helpManifest.find(s => s.slug === section)
  const firstChild = sectionEntry?.children?.[0]

  if (firstChild) {
    return <Redirect to={`${basePath}/${firstChild.slug.replace(`${section}/`, '')}`} />
  }

  return (
    <div className='p-4'>
      <h1>{sectionEntry?.title || 'Section'}</h1>
      <p>No articles in this section yet.</p>
    </div>
  )
}

function ArticlePage () {
  const { section, article } = useParams()
  const slug = `${section}/${article}`

  return <HelpArticle slug={slug} />
}

function HelpApp () {
  const { path } = useRouteMatch()

  return (
    <HelpLayout>
      <Switch>
        <Route path={`${path}/:section/:article`}>
          <ArticlePage />
        </Route>
        <Route path={`${path}/:section`} exact>
          <SectionLanding />
        </Route>
        <Route path={path} exact>
          <HelpLanding />
        </Route>
      </Switch>
    </HelpLayout>
  )
}

export default HelpApp
